module.exports = __webpack_public_path__ + "static/img/address_ts.e4f58de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/address_ts.png
// module id = 0cS/
// module chunks = 29